/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Outlet } from 'react-router-dom'
import ModalChangePassword from '../../components/modal/changepassword/ModalChangePassword'
import ModalLogout from '../../components/modal/logout/ModalLogout'
import Notification from '../../components/Notifications/Notification'
import { UserContext } from '../../context/userContext'
import Drawer from './Drawer'
import DrawerChangeWarehouse from './DrawerChangeWarehouse'
import NavbarPage from './Navbar'
import Sidebar from './Sidebar'
import { io } from 'socket.io-client'
import { useWarehouseRole } from '../../context/WarehouseProvider'
import styles from './dashboard.module.css'
import { Toaster } from 'react-hot-toast'
import { APP_VERSION } from '../../config/version.js'

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(true)
  const [state, dispatch] = useContext(UserContext)
  const { warehouseRole, updateWarehouseRole } = useWarehouseRole()
  const [note, setNote] = useState(false)
  const [indicator, setIndicator] = useState(false)
  const [width, setWidth] = useState(window.innerWidth)
  const [showCanvas, setShowCanvas] = useState(false)
  const [showCanvasWarehouse, setShowCanvasWarehouse] = useState(false)
  const [showModalChangePassword, setShowModalChangePassword] = useState(false)
  const [showModalLogout, setShowModalLogout] = useState(false)
  const socket = io.connect(
    process.env.REACT_APP_SOCKET_API_URL || 'https://bajnewbe.3qt9.lyr.id/'
  )

  useEffect(() => {
    if (!warehouseRole) {
      updateWarehouseRole(state?.username?.warehouse_active)
    }
  }, [])

  useEffect(() => {
    socket.on(`${warehouseRole}`, (data) => {
      setNote(data)
      setIndicator(Boolean(data))
    })

    return () => {
      socket.off('wms')
    }
  }, [socket])

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleCloseCanvas = () => {
    setShowCanvas(false)
  }

  const handleLogOut = () => {
    setShowModalLogout(true)
  }

  const confirmLogOut = () => {
    dispatch({ type: 'logout' })
  }

  return (
    <div className={styles.dashboardContainer}>
      <Container fluid className="p-0">
        <Row className="g-0">
          <Col
            xs={collapsed ? 3 : 3}
            md={collapsed ? 2 : 1}
            className={`${styles.sidebarContainer} ${
              width < 768 ? 'd-none' : ''
            }`}
          >
            <Sidebar collapsed={collapsed} />
          </Col>

          <Col
            md={{ span: collapsed ? 10 : 11, offset: collapsed ? 2 : 1 }}
            xs={12}
            className={styles.mainContent}
          >
            <div>
              <NavbarPage
                onClick={() => setCollapsed(!collapsed)}
                test={collapsed}
                indicator={indicator}
                width={width}
                setShowCanvas={setShowCanvas}
                setShowCanvasWarehouse={setShowCanvasWarehouse}
                usernameProp={state}
              />
            </div>

            <div className="mt-4 px-3 pt-3">
              {note && (
                <Notification
                  text={note?.message}
                  handleClose={() => setNote(null)}
                  link={note?.link}
                />
              )}
              <div className={styles.contentWrapper}>
                <Outlet />
              </div>
              <Row className={`${styles.footer} mx-0`}>
                <Col md={6} xs={6} className="text-start px-4">
                  <small>
                    &copy; 2024 Bahtera Adi Jaya &bull; v{APP_VERSION}
                  </small>
                </Col>
                <Col md={6} xs={6} className="text-end px-4">
                  <small>
                    Powered by <strong className="text-danger">RAPIER</strong>
                  </small>
                </Col>
              </Row>
            </div>

            <Drawer
              showCanvas={showCanvas}
              handleCloseCanvas={handleCloseCanvas}
            />
            <DrawerChangeWarehouse
              showCanvasWarehouse={showCanvasWarehouse}
              handleCloseCanvasWarehouse={() => setShowCanvasWarehouse(false)}
              setShowModalChangePassword={setShowModalChangePassword}
              handleLogOut={handleLogOut}
            />
          </Col>
        </Row>
      </Container>
      <ModalChangePassword
        show={showModalChangePassword}
        onHide={() => setShowModalChangePassword(false)}
      />
      <ModalLogout
        show={showModalLogout}
        onHide={() => setShowModalLogout(false)}
        onConfirm={confirmLogOut}
      />

      <Toaster />
    </div>
  )
}

export default Dashboard
